import { useState } from 'react'
import { useRequest, useView } from '@10000/react'
import { Avatar, AvatarDialog, Body, Box, Button, DeleteAccountDialog } from '../../widgets'
import { industries } from '../../../lookups'
import { DropDown, Location, Text } from '../../forms'
import { SettingsForm } from '../'

export const Account = ({ superUserMode, goBackToSettingsMenu }) => {
  const request = useRequest('tenant')
  const { company: { name, avatar, country, city, industry } } = useView('tenant')

  const [deleteAccountDialogOpen, setDeleteAccountDialogOpen] = useState(false)
  const [avatarDialogOpen, setAvatarDialogOpen] = useState(false)
  const [selectedAvatar, setSelectedAvatar] = useState(avatar)

  const formattedIndustries = industries.map((industry, index) => ({  label: industry.name, value: index }))

  const saveCompany = ({ name, country, city, industry }) => {
    return request('companyUpdated', { name, country, city, industry, avatar: selectedAvatar })
  }

  const avatarSelected = (avatar) => {
    setSelectedAvatar(avatar)
    setAvatarDialogOpen(false)
  }

  return <SettingsForm
    onSubmit={saveCompany}
    values={{ name, country, city, industry }}
    title="Account"
    backButtonMobileOnly
    onBackButtonClick={goBackToSettingsMenu}
  >
    <Box gap={16} alignItems="center" justifyContent="flex-start" fullWidth>
      <Avatar
        index={selectedAvatar}
        mode="company"
      />
      <Button className="small" onClick={() => setAvatarDialogOpen(true)}>
        Change avatar
      </Button>
    </Box>
    <Text title="Company name" name="name" value={name} required dark />
    <Location dark country={country} />

    <DropDown
      fullWidth
      dark
      name="industry"
      title="Industry"
      required
      options={formattedIndustries}
    />

    {!superUserMode && (
      <Box fullWidth p="32px 0" justifyContent="flex-start">
        <Box cursor="pointer" onClick={() => setDeleteAccountDialogOpen(true)}>
          <Body underline bold alt italic>Delete Account</Body>
        </Box>
      </Box>
    )}

    <AvatarDialog
      value={selectedAvatar}
      mode="company"
      open={avatarDialogOpen}
      onClose={avatarSelected}
    />
    {!superUserMode && (
      <DeleteAccountDialog
        open={deleteAccountDialogOpen}
        onClose={() => setDeleteAccountDialogOpen(false)}
      />
    )}
  </SettingsForm>
}

